import { InfiniteData } from 'react-query';

import { PageResult } from '@/core/request/PageResult';

export function flatInfiniteData<T>(
  data: InfiniteData<Partial<PageResult<T>>> | undefined,
): T[] {
  if (!data || !data.pages.every((page) => !!page.data)) return [];

  return (
    data?.pages.reduce<T[]>(
      (acc, curr) => [...acc, ...(curr.data || [])],
      [],
    ) || []
  );
}
